import { render, staticRenderFns } from "./RoyalMail.vue?vue&type=template&id=5f015790&scoped=true&"
import script from "./RoyalMail.vue?vue&type=script&lang=js&"
export * from "./RoyalMail.vue?vue&type=script&lang=js&"
import style0 from "./RoyalMail.vue?vue&type=style&index=0&id=5f015790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f015790",
  null
  
)

export default component.exports